<template>
  <div>
    <h1 v-html="heading" />
    <section>
      <article class="flow-group">
        <div class="header-with-icon push-down">
          <span class="icon-large" :class="'policy-type-name-' + [vueModel.Type]" />
          <ul class="no-bullet">
            <li
              v-for="(asset, index) in vueModel.Asset.AssetDetailLines"
              :key="index"
              v-html="asset"
            />
          </ul>
        </div>

        <sellers-insurance
          :external-vue-model="vueModel"
          :external-sellers-insurance-model="proposalModel.SellersInsurance"
          @sellers-insurance-updated="sellersInsuranceUpdated"
        />

        <takeover-information
          v-if="vueModel.AdditionalInformation.HasInsurance"
          :external-vue-model="vueModel.AdditionalInformation.TakeoverInformation"
          :external-takeover-model="proposalModel.TakeoverModel"
          :mitid-model="mitIdModel"
        />

        <file-attach
          v-if="
            vueModel.AppraisalType !== 1000001 &&
            !vueModel.AdditionalInformation.HasInsurance &&
            vueModel.AdditionalInformation.HasInsurance !== null
          "
          v-model="vueModel.Files"
          :title="proposalModel.AppraisalModel.LabelAppraisalDocumentation"
          :description="proposalModel.AppraisalModel.DescriptionAppraisalDocumentation"
          :add-file-label="proposalModel.AppraisalModel.LabelAddAppraisalDocument"
          :remove-file-label="proposalModel.AppraisalModel.LabelRemoveAppraisalDocument"
          :max-file-bundle-size="
            proposalModel.AppraisalModel.MaxFileBundleSizeAppraisalDocumentation
          "
          :data-vv-as="proposalModel.AppraisalModel.FieldNameAppraisalDocumentation"
          required="required"
        />

        <!-- <div
                    v-if="vueModel.AppraisalType !== 1000001 && !vueModel.AdditionalInformation.HasInsurance && vueModel.AdditionalInformation.HasInsurance !== null"
                    class="info-box is-shown info-box-align-right"
                    v-html="proposalModel.AppraisalModel.TextAppraisalHasNoInsurance"
                />

                <div
                    v-if="vueModel.AppraisalType !== 1000001 && vueModel.AdditionalInformation.HasInsurance && vueModel.AdditionalInformation.HasInsurance !== null"
                    class="info-box is-shown info-box-no-arrow"
                    v-html="proposalModel.AppraisalModel.TextAppraisalHasInsurance"
                /> -->
      </article>
    </section>
  </div>
</template>

<script>
import FileAttach from './FileAttach.vue';
import SellersInsurance from './Shared/AdditionalInformation/SellersInsurance.vue';
import TakeoverInformation from './Shared/AdditionalInformation/TakeoverInformation.vue';
import mixin from './CheckoutMixin.vue';

export default {
  name: 'House',
  components: {
    FileAttach,
    SellersInsurance,
    TakeoverInformation
  },
  mixins: [mixin],
  props: {
    externalVueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    proposalModel: {
      type: Object,
      default() {
        return {};
      }
    },
    extVueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel,
      mitIdModel: this.extVueModel.Content.MitIdModal
    };
  },
  computed: {
    heading() {
      if (
        this.vueModel &&
        this.vueModel.Name &&
        this.proposalModel &&
        this.proposalModel.LabelExtraInformationForYour
      ) {
        return `${this.proposalModel.LabelExtraInformationForYour} ${this.vueModel.Name.toLowerCase()}`;
      }

      return '';
    }
  },
  watch: {
    'vueModel.AdditionalInformation.InsuranceReason': function () {
      if (this.vueModel.AdditionalInformation.InsuranceReason === 1) {
        this.$nextTick(() => {
          window.Utility.scrollToElem(
            $('#CurrentInsuranceCompany'),
            Utility.getScrollOffset(false)
          );
        });
      }
    },
    'vueModel.AdditionalInformation.TakeoverInformation.TakeoverType': function () {
      if (this.vueModel.AdditionalInformation.TakeoverInformation.TakeoverType === 1) {
        this.$nextTick(() => {
          window.Utility.scrollToElem($('#SelectedTakeoverDate'), Utility.getScrollOffset(false));
        });
      }
    },
    'vueModel.AdditionalInformation.HasInsurance': function () {
      this.emptyArray(this.vueModel.Files);
    },
    vueModel: {
      handler() {
        this.$emit('vue-model-updated', this.vueModel);
      },
      deep: true
    }
  },
  methods: {
    sellersInsuranceUpdated(param) {
      this.vueModel = param;
    }
  }
};
</script>
